import AlertMessage from './alert-message';
import Link from './link';
import Media from './media';
import PdpValueTile from './pdp-value-tile';
import ARQuickLook from './ar-quick-look';
import WarrantyItem from './warranty-item';
import Promo from './promo';
import Richtext from './richtext';

export class PdpContentWell {
  price: string | undefined;
  description: Richtext | undefined;
  secondLine: string | undefined;
  secondLineSubtext: Richtext | undefined;
  cta: Link | undefined;
  priceSubtextLink: Link | undefined;
  breadErrorMessage: AlertMessage | undefined;
  estimatedDeliveryDays: number | undefined;
  estimatedDeliveryText: string | undefined;
  eqxIcon: any;
  membershipPrice: string | undefined;
  membershipPriceText: string | undefined;
  miniBoxes: PdpValueTile[] | undefined;
  pdpQuickLook: ARQuickLook | undefined;
  warrantyText: string | undefined;
  warrantyIcon: Media | undefined;
  warrantyItems: WarrantyItem[] | undefined;
  promo: Promo | undefined;
  bikePrice?: number;

  constructor(props: any) {
    if (!props) return;

    this.price = props.mainBox?.price;
    this.description = props.mainBox?.description;
    this.secondLine = props.mainBox?.secondLine;
    this.secondLineSubtext = props.mainBox?.secondLineSubtext;
    this.cta = props.mainBox?.cta ? new Link(props.mainBox.cta) : undefined;
    this.priceSubtextLink = props.mainBox?.priceSubtextLink
      ? new Link(props.mainBox.priceSubtextLink)
      : undefined;
    this.breadErrorMessage = props.mainBox?.breadErrorMessage
      ? new AlertMessage(props.mainBox.breadErrorMessage)
      : undefined;
    this.estimatedDeliveryDays = props.mainBox?.estimatedDeliveryDays;
    this.estimatedDeliveryText = props.mainBox?.estimatedDeliveryText;
    this.eqxIcon = props.mainBox?.eqxIcon
      ? new Media(props.mainBox.eqxIcon)
      : undefined;
    this.membershipPrice = props.mainBox?.membershipPrice;
    this.membershipPriceText = props.mainBox?.membershipPriceText;
    this.miniBoxes = props.miniBoxesCollection?.items?.map(
      (box: any) => new PdpValueTile(box)
    );
    this.pdpQuickLook = props.pdpQuickLook
      ? new ARQuickLook(props.pdpQuickLook)
      : undefined;
    this.warrantyText = props.mainBox?.warrantyText;
    this.warrantyIcon = props.mainBox?.warrantyIcon
      ? new Media(props.mainBox.warrantyIcon)
      : undefined;
    this.warrantyItems = props.mainBox?.warrantyItemsCollection?.items?.map(
      (item: any) => new WarrantyItem(item)
    );
    this.promo = props.promo ? new Promo(props.promo) : undefined;
    this.bikePrice = props.bikePrice;
  }
}

export default PdpContentWell;
